import React from 'react';
import Cart from '../Components/Cart'
import { translate } from '../Services/translation';

const MiniCart = (cart) => {
  const { toggle, updateOrderRowQuantity, removeOrderRow } = cart;
  const channel = cart.channel;
  let cartIcon = "/ui/images/shopping-cart.svg";
  if (channel == 'streckkod') {
    cartIcon = "/ui/images/cart-black.svg"
  }
  console.log(channel)
  return (
    <div className="cart cart--mini">
      <a className="button cart__link--block" href={cart.checkoutUrl}>
        <img className="dark-icon" src={cartIcon} alt="Cart icon" />
        <span className="button-text text-light">{translate('cart.cart')}</span>
        <span className="cart__quantity">{cart.quantity}</span>
      </a>
    </div>
  )
}
export default MiniCart;
